import { TransitionManager } from '../transitions/TransitionManager.js';
import { transitionLog } from '../debug/transitionDebug.js';

/**
 * On `body[data-world]` (Vite world pages), in-site links to the portfolio root
 * (e.g. `/#worlds` or `/`) run `TransitionManager.transitionOut` (assigns
 * `location` — no WebGL cover).
 *
 * New-tab / modified clicks use default browser behavior.
 * Opt out: <a data-no-transition href="...">
 */

function isPortfolioRootNavigation(anchor) {
  if (anchor.hasAttribute('data-no-transition')) return false;
  if (anchor.getAttribute('target') === '_blank' || anchor.getAttribute('download') != null) {
    return false;
  }
  const href = anchor.getAttribute('href');
  if (href == null || href === '') return false;
  if (/^(mailto|tel|javascript):/i.test(href)) return false;

  let u;
  try {
    u = new URL(anchor.href, location.href);
  } catch {
    return false;
  }
  if (u.origin !== location.origin) return false;
  const path = u.pathname.replace(/\/+$/, '') || '/';
  if (path !== '/' && path !== '/index.html') return false;
  return true;
}

function onClickCapture(e) {
  if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
    return;
  }
  const a = e.target && e.target.closest && e.target.closest('a[href]');
  if (!a) return;
  if (!isPortfolioRootNavigation(a)) return;

  e.preventDefault();

  if (TransitionManager.isNavigating()) {
    transitionLog('wire:nav_ignored', {
      reason: 'already_navigating',
      href: a.getAttribute('href'),
      timeStamp: e.timeStamp,
    });
    return;
  }

  transitionLog('wire:nav_click', {
    eventType: e.type,
    timeStamp: e.timeStamp,
    defaultPrevented: e.defaultPrevented,
    href: a.getAttribute('href'),
    willNavigate: a.href,
  });
  TransitionManager.transitionOut(a.href);
}

let _wired = false;

export function wireWorldPageTransitions() {
  if (typeof document === 'undefined' || !document.body?.dataset?.world) {
    return;
  }
  if (_wired) {
    transitionLog('wire:dup_init', { world: document.body.dataset.world, path: location.pathname });
    return;
  }
  _wired = true;
  transitionLog('wire:init', { world: document.body.dataset.world, path: location.pathname });
  document.addEventListener('click', onClickCapture, true);
}
